import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LANG_STORAGE_KEY, LANG_LIST, type LangCode } from './languages';

// Static imports keep the bundle smaller than lazy http-backend for our small pack sizes.
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enHome from './locales/en/home.json';
import enTrip from './locales/en/trip.json';
import enVehicle from './locales/en/vehicle.json';
import enProfile from './locales/en/profile.json';
import enHelp from './locales/en/help.json';
import enMenu from './locales/en/menu.json';

import hiCommon from './locales/hi/common.json';
import hiAuth from './locales/hi/auth.json';
import hiHome from './locales/hi/home.json';
import hiTrip from './locales/hi/trip.json';
import hiVehicle from './locales/hi/vehicle.json';
import hiProfile from './locales/hi/profile.json';
import hiHelp from './locales/hi/help.json';
import hiMenu from './locales/hi/menu.json';

import taCommon from './locales/ta/common.json';
import taAuth from './locales/ta/auth.json';
import taHome from './locales/ta/home.json';
import taTrip from './locales/ta/trip.json';
import taVehicle from './locales/ta/vehicle.json';
import taProfile from './locales/ta/profile.json';
import taHelp from './locales/ta/help.json';
import taMenu from './locales/ta/menu.json';

import teCommon from './locales/te/common.json';
import teAuth from './locales/te/auth.json';
import teHome from './locales/te/home.json';
import teTrip from './locales/te/trip.json';
import teVehicle from './locales/te/vehicle.json';
import teProfile from './locales/te/profile.json';
import teHelp from './locales/te/help.json';
import teMenu from './locales/te/menu.json';

import knCommon from './locales/kn/common.json';
import knAuth from './locales/kn/auth.json';
import knHome from './locales/kn/home.json';
import knTrip from './locales/kn/trip.json';
import knVehicle from './locales/kn/vehicle.json';
import knProfile from './locales/kn/profile.json';
import knHelp from './locales/kn/help.json';
import knMenu from './locales/kn/menu.json';

import mrCommon from './locales/mr/common.json';
import mrAuth from './locales/mr/auth.json';
import mrHome from './locales/mr/home.json';
import mrTrip from './locales/mr/trip.json';
import mrVehicle from './locales/mr/vehicle.json';
import mrProfile from './locales/mr/profile.json';
import mrHelp from './locales/mr/help.json';
import mrMenu from './locales/mr/menu.json';

import bnCommon from './locales/bn/common.json';
import bnAuth from './locales/bn/auth.json';
import bnHome from './locales/bn/home.json';
import bnTrip from './locales/bn/trip.json';
import bnVehicle from './locales/bn/vehicle.json';
import bnProfile from './locales/bn/profile.json';
import bnHelp from './locales/bn/help.json';
import bnMenu from './locales/bn/menu.json';

import guCommon from './locales/gu/common.json';
import guAuth from './locales/gu/auth.json';
import guHome from './locales/gu/home.json';
import guTrip from './locales/gu/trip.json';
import guVehicle from './locales/gu/vehicle.json';
import guProfile from './locales/gu/profile.json';
import guHelp from './locales/gu/help.json';
import guMenu from './locales/gu/menu.json';

const resources = {
  en: { common: enCommon, auth: enAuth, home: enHome, trip: enTrip, vehicle: enVehicle, profile: enProfile, help: enHelp, menu: enMenu },
  hi: { common: hiCommon, auth: hiAuth, home: hiHome, trip: hiTrip, vehicle: hiVehicle, profile: hiProfile, help: hiHelp, menu: hiMenu },
  ta: { common: taCommon, auth: taAuth, home: taHome, trip: taTrip, vehicle: taVehicle, profile: taProfile, help: taHelp, menu: taMenu },
  te: { common: teCommon, auth: teAuth, home: teHome, trip: teTrip, vehicle: teVehicle, profile: teProfile, help: teHelp, menu: teMenu },
  kn: { common: knCommon, auth: knAuth, home: knHome, trip: knTrip, vehicle: knVehicle, profile: knProfile, help: knHelp, menu: knMenu },
  mr: { common: mrCommon, auth: mrAuth, home: mrHome, trip: mrTrip, vehicle: mrVehicle, profile: mrProfile, help: mrHelp, menu: mrMenu },
  bn: { common: bnCommon, auth: bnAuth, home: bnHome, trip: bnTrip, vehicle: bnVehicle, profile: bnProfile, help: bnHelp, menu: bnMenu },
  gu: { common: guCommon, auth: guAuth, home: guHome, trip: guTrip, vehicle: guVehicle, profile: guProfile, help: guHelp, menu: guMenu },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: LANG_LIST.map(l => l.code),
    ns: ['common', 'auth', 'home', 'trip', 'vehicle', 'profile', 'help', 'menu'],
    defaultNS: 'common',
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANG_STORAGE_KEY,
      caches: ['localStorage'],
    },
  });

export default i18n;

export function setLanguage(code: LangCode) {
  i18n.changeLanguage(code);
  localStorage.setItem(LANG_STORAGE_KEY, code);
}

export function currentLanguage(): LangCode {
  return (i18n.language?.split('-')[0] as LangCode) || 'en';
}
